module.exports = __webpack_public_path__ + "static/media/intro.3ae0f08d.jpg";